function numberRangeMessage(min?: number | null, max?: number | null): string | undefined {
	if (min == null && max == null) return undefined;
	if (max == null) return `Must be at least ${min}`;
	if (min == null) return `Must be at most ${max}`;
	return `Must be between ${min} and ${max}`;
}

export default numberRangeMessage;
